import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "reactstrap";
import { getDesignations } from "../../services/designationService";
import { toast } from "react-toastify";
import AddDesignations from "./AddDesignations";
import DeleteDesignation from "./DeleteDesignation";
import EditDesignation from "./EditDesignation";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  ButtonGroup,
  Breadcrumb,
  Form,
} from "@themesberg/react-bootstrap";

import SpinDiv from "../components/SpinDiv";

export class DesignationIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      designations: [],
      value:"",
      total: 0,
    }
  }

  componentDidMount() {
   this.getDesignations();
  }

  toggleDeleteDesignation=(deleteDesignation)=>{
    this.setState({ deleteDesignation });
  }

  toggle = () => {
    this.setState({ deleteDesignation: !this.state.deleteDesignation });
  }
  

  showToast = (msg) => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  };
  getDesignations = () => {

    const { page, rows, search} = this.state;
    this.setState({ loading: true });
    getDesignations({ page, rows, search }).then(
      (res) => {
        this.setState({
          loading: false,
          designations:res.designations.data,
          total:res.designations.total
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

  

  toggleAddDesignation = () => {
    this.setState({ addDesignations: !this.state.addDesignations });
  };
  
  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  toggleEdit = (editDesignation) => {
    this.setState({ editDesignation });
  };

  
  
  render() {
    const {
      designations,
      total,
      addDesignations,
      editDesignation,
      deleteDesignation,
      rows,
      search,
      loading,
      filtering
    } = this.state;
    return (
      <>
      
        {addDesignations && (
          <AddDesignations
            saved={this.getDesignations}
            addDesignations={addDesignations}
            toggle={() => this.setState({ addDesignations: null })}
          />
        )}

        {editDesignation && (
          <EditDesignation
            saved={this.getDesignations}
            editDesignation={editDesignation}
            toggle={() => this.setState({ editDesignation: null })}
          />
        )}

        {deleteDesignation && (
          <DeleteDesignation
            saved={this.getDesignations}
            designation={deleteDesignation}
            toggle={this.toggle}
          />
        )}


       

        {loading && <SpinDiv text={"Loading..."} />}
        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#products">products</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => this.toggleAddDesignation()}
                  >
                    Create Designations
                  </Button>
                  
                  {/* <Button variant="outline-primary" size="sm">
                    Export
                  </Button> */}
                </ButtonGroup>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="7">
            <h6>Designations({total})</h6>
           
          </Col>
          
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                id="show"
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                value={search}
                onChange={(e) => this.onChange(e.target.value, "search")}
                autoFocus
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.getDesignations();
                    this.setState({
                      search: "",
                    });
                  }
                }}
              />
              <Button
                className="btn-icon btn-2"
                color="secondary"
                style={{ maxHeight: 45 }}
                size="sm"
                onClick={this.getDesignations}
              >
                <i className="fa fa-search" />
              </Button>
            </div>
          </Col>
        </Row>
        
        <Card border="light" className="shadow-sm mb-4">
          
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Designation</th>
                  <th className="border-0">No of Employees</th>
                </tr>
              </thead>
              <tbody>
            
                {designations.map((designation, key) => {
                  return (
                    <tr key={key}>
                      <td>{designation.name}</td>
                      <td>{designation.employees_count}</td>
                      <td>
                            <ButtonGroup>
                            <Button
                              variant="outline-primary" 
                              onClick={() => this.toggleEdit(designation)}
                              size="sm"
                            >
                              Edit
                            </Button>
                            <Button
                            variant="outline-danger"
                            onClick={() => {
                              this.toggleDeleteDesignation(designation)
                            }}            
                            size="sm"
                          >
                            Delete
                          </Button>
                            </ButtonGroup>
                      </td>
                      
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default DesignationIndex;
